module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp1-04-05799197076456f282a2e91142bb5400.png";